export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MyRatings.vue?vue&type=template&id=560945f6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/MyRatings.vue?vue&type=template&id=560945f6&scoped=true&
// module id = 574
// module chunks = 6